import type { InvoiceRow, PaymentRow } from '../types';

function parseMoney(value: string | null): number {
  if (value === null) return 0;
  const n = Number.parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

function round2(value: number): number {
  return Number(value.toFixed(2));
}

// Sum of recorded payments, ignoring soft-deleted rows. Non-finite or null
// amounts count as zero.
export function sumPaid(payments: readonly PaymentRow[]): number {
  const total = payments.reduce<number>((acc, payment) => {
    if (payment.deleted_at !== null) return acc;
    return acc + parseMoney(payment.total_amount_paid);
  }, 0);
  return round2(total);
}

// What remains owed after applied downpayment, applied provisional, and
// recorded payments are netted off the invoice total. Never negative; a null
// total means nothing is outstanding.
export function computeOutstanding(invoice: InvoiceRow, payments: readonly PaymentRow[]): number {
  if (invoice.total_amount === null) return 0;
  const outstanding =
    parseMoney(invoice.total_amount) -
    parseMoney(invoice.applied_downpayment_amount) -
    parseMoney(invoice.applied_provisional_amount) -
    sumPaid(payments);
  return round2(Math.max(0, outstanding));
}
